import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';

import {
  deleteCadastroPosto,
  findCadastroPosto,
  recordFiltering,
} from '~/store/modules/cadastroposto/actions';

import CadastroPostoForm from './form';

export default function CadastroPosto() {
  const redux = useSelector((state) => state.cadastroposto);

  const optionsStatus = useMemo(
    () => [
      { label: '1', value: 'liberado' },
      { label: '2', value: 'bloqueado' },
      { label: '3', value: 'cancelado' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'orga_nome',
        label: 'Órgão:',
        filter: { type: 'text' },
        align: 'left',
      },
      {
        id: 'unid_nome',
        label: 'Unidade',
        filter: { type: 'text' },
        align: 'left',
      },
      {
        id: 'poco_codigo',
        label: 'Código',
        filter: { type: 'text' },
        align: 'right',
      },
      {
        id: 'poco_descricao',
        label: 'Descrição',
        filter: { type: 'text' },
        align: 'left',
      },
      {
        id: 'poco_desc_abrev',
        label: 'Descrição Abrev.',
        filter: { type: 'text' },
        align: 'left',
      },
      {
        id: 'poco_codigo_aux',
        label: 'Código Aux.',
        filter: { type: 'text' },
        align: 'right',
      },
      {
        id: 'poco_endereco',
        label: 'Endereço',
        filter: { type: 'text' },
        align: 'left',
      },
      {
        id: 'poco_cep',
        label: 'CEP',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'muni_nome',
        label: 'Município',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_percentual_dif_turno',
        label: 'Dif. Máxima Turno',
        filter: { type: 'text' },
        align: 'right',
      },
      {
        id: 'poco_recebe_transf_string',
        label: 'Recebe Transf.',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_le_temp_bico_string',
        label: 'Temp. Bico',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_controla_tanque_string',
        label: 'Controla Tanque',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_turno_terminal_string',
        label: 'Opera Turno Term.',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_recebimento_terminal_string',
        label: 'Opera Receb. Term.',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_contr_int_siad_string',
        label: 'Opera Interface SAP.',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_interface_siad_string',
        label: 'Interface SAP. Habilitada',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_recebimento_fracionado_string',
        label: 'Rec. Fracionado Habilitada',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_tem_telemetria_string',
        label: 'Tem Telemetria',
        filter: { type: 'text' },
        align: 'center',
      },
      {
        id: 'poco_interface_stock300_liberado_string',
        label: 'Interface STOCK300 Habilitada',
        filter: { type: 'text' },
        align: 'center',
      },

      {
        id: 'poco_status_string',
        label: 'Status',
        align: 'center',
        filter: { type: 'select', options: optionsStatus },
      },
    ],
    [optionsStatus]
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="poco_desc_abrev ASC"
      header={header}
      redux={redux}
      read={recordFiltering}
      remove={deleteCadastroPosto}
      find={findCadastroPosto}
      form={CadastroPostoForm}
      detach="poco_codigo"
      keys="poco_codigo"
      view="VW_POSTO_CONFIG"
      reportTitle="Cadastro de Posto"
    />
  );
}
